'use client'
import React from 'react';
import parser from 'react-html-parser';
import styled from "styled-components";

const SliderItem = ({title}) => {
    return (
        <SlideInnerInfo>
            <div className="slide-inner__info d-flex" data-speed={"clamp(1.15)"}>
                <h1 className="split-up">{title && typeof title === 'string' && parser(title)}</h1>
            </div>
        </SlideInnerInfo>
    );
};

const SlideInnerInfo = styled.div`

    .slide-inner__info{

        position: relative;
        overflow: hidden;
        h1 {

            font-weight: 400;
            color: #FFFFFF;

            span {
                font-weight: 800;
            }


        }

        .dc-btn {
            position: relative;
            transform: translateY(400px);
            transition-delay: 0.5s;
            transition: 3s all cubic-bezier(0.4, 0, 0, 1);

        }
        
        @media(min-width: 1550px){
            position: relative;
            overflow: hidden;
            h2 {
                font-size: 80px;
                line-height: 115px;
            }
            .dc-btn {
                a {
                    font-size: 22px;
                    line-height: 33px;
                }
            }
        }
        @media(max-width: 767px){
            position: relative;
            overflow: hidden;

            h2 {
                font-size: 34px;
                line-height: 40px;

                br {
                    display: none;
                }

                span {
                    margin-left: 0px;
                    //padding-left: offset;
                }

            }


            .dc-btn {
                margin-top: 30px;
            }
        }
    }

    
`
export default SliderItem;
